<!-- En compacto el modal es hoja inferior: arrastrar el header hacia abajo lo cierra -->
<div
  class="modal-header d-flex bg-primary p-2 align-items-center justify-content-between"
  appSheetSwipe
  sheetSelector=".modal-content"
  [dismissOnSwipeDown]="true"
  (swipeDown)="closed()"
>
  <div class="d-flex align-items-center flex-wrap p-2">
    <div class="d-none d-lg-flex align-items-center mr-2">
      <app-image-color
        [height]="'20px'"
        [width]="'40px'"
        [url]="'client/wifi.svg'"
        [color]="'#ffffff'"
      ></app-image-color>
    </div>
    <div class="line bg-white d-none d-lg-flex"></div>
    <div class="text-left ml-2">
      <div class="flex-column">
        <h2 class="mb-0 d-flex align-items-start">
          {{ "admin.network-config.gateway-form" | translate }}
        </h2>
        <p class="m-0">{{ "admin.network-config.gateway-create-edit" | translate }}</p>
      </div>
    </div>
  </div>

  <h3 class="m-0 c-pointer" (click)="closed()">&times;</h3>
</div>
<div class="modal-body p-0">
  <div class="w-100 text-center mt-2">
    <p class="mb-0 font-11">
      <b>{{ "general.obligatory" | translate }}</b>
    </p>
  </div>

  <!-- Formulario y mapa en una sola columna; el boton de guardar va al final -->
  <div class="gateway-modal-body">
    <app-gateway-form #gatewayFormRef></app-gateway-form>

    <div class="mt-3">
      <app-gateway-installation></app-gateway-installation>
    </div>

    <div class="text-center mt-4">
      <button
        type="button"
        class="btn btn-success gateway-submit"
        [disabled]="!gatewayFormRef.validateButton(gatewayFormRef.gatewayForm.value)"
        (click)="gatewayFormRef.createGateway(gatewayFormRef.gatewayForm.value)"
      >
        {{ "general.save" | translate }}
      </button>
    </div>
  </div>
</div>
